<template>
  <div class="related-person-tab">
    <div style="max-height: 600px; overflow-y: auto;">
      <el-table 
        ref="multipleTable" 
        border 
        :cell-style="{padding: '3px'}" 
        :header-cell-style="{ background: '#FFF6EF'}" 
        style="width: 100%"  
        empty-text="暫無數據" 
        :data="relComRep"
      >
        <el-table-column label="關聯人" prop="Name" min-width="25%">
        </el-table-column>
        
        <el-table-column label="關聯關係" prop="JobTitle" min-width="25%">
        </el-table-column>
        
        <el-table-column label="所代表法人" prop="LegPersonRep" min-width="15%">
        </el-table-column>
        
        <el-table-column label="持股情形" prop="HoldStkNm" min-width="35%">
        </el-table-column>
        
        <el-table-column label="關聯公司" prop="RelComs" min-width="35%">
          <template slot-scope="scope">
            <div v-html="scope.row.RelComs"></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelatedPersonTab',
  
  props: {
    relComRep: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
/* 關聯人標籤頁樣式 */
</style>
